// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardTransactionInfoAPIModel
 */
export interface CardTransactionInfoAPIModel {
    /**
     * 
     * @type {string}
     * @memberof CardTransactionInfoAPIModel
     */
    bankId?: string;
    /**
     * 
     * @type {string}
     * @memberof CardTransactionInfoAPIModel
     */
    cardNumber?: string;
}

export function CardTransactionInfoAPIModelFromJSON(json: any): CardTransactionInfoAPIModel {
    return CardTransactionInfoAPIModelFromJSONTyped(json, false);
}

export function CardTransactionInfoAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardTransactionInfoAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bankId': !exists(json, 'bankId') ? undefined : json['bankId'],
        'cardNumber': !exists(json, 'cardNumber') ? undefined : json['cardNumber'],
    };
}

export function CardTransactionInfoAPIModelToJSON(value?: CardTransactionInfoAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bankId': value.bankId,
        'cardNumber': value.cardNumber,
    };
}


